import type { PaperWithRole } from "@/types/paper";

/**
 * IDs of scored papers whose score predates the concept's last *definition*
 * edit — i.e. scored against an older definition. `lastDefinitionEditAt` comes
 * from the backend (MAX of concept_versions.changed_at); null means the concept
 * was never definition-edited, so nothing is stale.
 */
export function staleScoredPaperIds(
  papers: PaperWithRole[],
  lastDefinitionEditAt: string | null,
): string[] {
  if (!lastDefinitionEditAt) return [];
  const editedAt = Date.parse(lastDefinitionEditAt);
  const ids: string[] = [];
  for (const paper of papers) {
    if (
      (paper.relevance_score ?? 0) > 0 &&
      paper.scoring_timestamp &&
      Date.parse(paper.scoring_timestamp) < editedAt
    ) {
      ids.push(paper.id);
    }
  }
  return ids;
}
